import React, { useEffect, useState, useCallback } from "react";
import config from "../../config/config";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';



// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
// import Slider from "react-slick";
const AboutPage = () => {
  const [users, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
      const [bannerData, setBannerData] = useState([]);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  // ✅ Fetch data function
  const getList = useCallback(async () => {
    try {
      setLoading(true);
      const result = await config.getAllUsers();
      setUserData(result.data || []); // ✅ Update state (not local variable)
      setError(null);
    } catch (err) {
      setUserData([]);
      setError(null); // Silently fail
    } finally {
      setLoading(false);
    }
  }, []);

  // ✅ Run only once
  useEffect(() => {
    getList();
    banner();
  }, [getList]);
  let banner = async () => {
  const result = await config.getBannerByName("home");
  setBannerData(result.data || {});
};
const heroStyle = bannerData
  ? {
      backgroundImage: `url(${config.IMAGE_URL}banners/${bannerData.image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "50vh",
    }
  : {};
  return (
    <>
      <section>
        <div className="head">

        </div>
      </section>
      {/* Hero Section */}

      <section className="hero" style={heroStyle}>
        <div className="hero-content">
          <h1>About RoomsForYou</h1>
          <p>Transforming real estate with trust, innovation, and expertise since day one</p>
        </div>
      </section>

      {/* Mission / Values */}
      <section className="featured">
        <div className="max-w-6xl mx-auto my-10 p-4 text-center">
          <h2 className="text-3xl font-bold mb-3">Our Mission</h2>
          <p className="mb-6">We exist to make property search and management simple, transparent and trustworthy for everyone.</p>

          <div className="grid" style={{display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:20}}>
            <div className="help-card">
              <h3>Customer First</h3>
              <p>We prioritize verified listings and support to deliver great outcomes.</p>
            </div>
            <div className="help-card">
              <h3>Integrity</h3>
              <p>Transparent pricing, clear communication and reliable partners.</p>
            </div>
            <div className="help-card">
              <h3>Fast Results</h3>
              <p>Tools and experts to help you sell, rent or buy quickly.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="featured" style={{backgroundColor: '#f9f9f9', padding: '60px 20px'}}>
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold mb-6 text-center">Our Story</h2>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', alignItems: 'center'}}>
            <div>
              <p className="mb-4 text-gray-700 leading-relaxed">
                Founded in 2020, RoomsForYou started with a simple vision: to democratize real estate by removing barriers between buyers, sellers, and renters. We saw too many people struggling with outdated systems, unclear pricing, and untrustworthy agents.
              </p>
              <p className="mb-4 text-gray-700 leading-relaxed">
                Today, we've helped thousands of families find their perfect homes, enabled property owners to reach qualified buyers and tenants, and built a community of trusted agents and professionals.
              </p>
              <p className="text-gray-700 leading-relaxed">
                We continue to innovate with cutting-edge technology, verified listings, and 24/7 customer support to make real estate simple, transparent, and trustworthy for everyone.
              </p>
            </div>
            <div style={{backgroundColor: '#e8f4f8', padding: '30px', borderRadius: '10px'}}>
              <h3 className="text-2xl font-bold mb-4">By The Numbers</h3>
              <div className="mb-4">
                <p style={{fontSize: '28px', fontWeight: 'bold', color: '#007bff'}}>50,000+</p>
                <p>Properties Listed</p>
              </div>
              <div className="mb-4">
                <p style={{fontSize: '28px', fontWeight: 'bold', color: '#007bff'}}>120,000+</p>
                <p>Active Users</p>
              </div>
              <div className="mb-4">
                <p style={{fontSize: '28px', fontWeight: 'bold', color: '#007bff'}}>30,000+</p>
                <p>Successful Transactions</p>
              </div>
              <div>
                <p style={{fontSize: '28px', fontWeight: 'bold', color: '#007bff'}}>98%</p>
                <p>Customer Satisfaction Rate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose RoomsForYou */}
      <section className="featured" style={{padding: '60px 20px'}}>
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold mb-6 text-center">Why Choose RoomsForYou?</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px'}}>
            <div style={{padding: '30px', border: '1px solid #e0e0e0', borderRadius: '8px', textAlign: 'center'}}>
              <h3 className="text-xl font-bold mb-3">✓ Verified Listings</h3>
              <p>Every property is carefully vetted. No scams, no surprises—just honest, transparent listings you can trust.</p>
            </div>
            <div style={{padding: '30px', border: '1px solid #e0e0e0', borderRadius: '8px', textAlign: 'center'}}>
              <h3 className="text-xl font-bold mb-3">✓ Expert Agents</h3>
              <p>Our team of certified, experienced agents is here to guide you—whether you're buying, selling, or renting.</p>
            </div>
            <div style={{padding: '30px', border: '1px solid #e0e0e0', borderRadius: '8px', textAlign: 'center'}}>
              <h3 className="text-xl font-bold mb-3">✓ Transparent Pricing</h3>
              <p>No hidden fees. Clear pricing breakdowns let you understand exactly what you're paying for.</p>
            </div>
            <div style={{padding: '30px', border: '1px solid #e0e0e0', borderRadius: '8px', textAlign: 'center'}}>
              <h3 className="text-xl font-bold mb-3">✓ 24/7 Support</h3>
              <p>Have a question at 2 AM? Our customer support team is always ready to help.</p>
            </div>
            <div style={{padding: '30px', border: '1px solid #e0e0e0', borderRadius: '8px', textAlign: 'center'}}>
              <h3 className="text-xl font-bold mb-3">✓ Smart Technology</h3>
              <p>Advanced search filters, virtual tours, and instant notifications help you find the right property faster.</p>
            </div>
            <div style={{padding: '30px', border: '1px solid #e0e0e0', borderRadius: '8px', textAlign: 'center'}}>
              <h3 className="text-xl font-bold mb-3">✓ Secure Transactions</h3>
              <p>All transactions are protected with escrow services and legal safeguards for peace of mind.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Agents */}
      <section className="featured" style={{backgroundColor: '#f9f9f9', padding: '60px 20px'}}>
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl font-semibold mb-6 text-center">Meet Our Top Agents</h2>
          <p className="text-center mb-8 text-gray-600">Experienced professionals dedicated to your success</p>

          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={30}
            slidesPerView={3}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            // onSwiper={(swiper) =>
            //    console.log(swiper)
            //   }
            onSlideChange={() => console.log("slide change")}
            className="property-swiper"
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 }
            }}
          >
            {loading ? (
              <div style={{padding: '40px', textAlign: 'center'}}>Loading agents...</div>
            ) : users.length > 0 ? (
              users.map((n) => {
                const firstImage = n.image ? n.image : 'user.png';
                return (
                  <SwiperSlide key={n._id}>
                    <div className="bg-white shadow rounded-lg overflow-hidden">
                      <img
                        src={`${config.IMAGE_URL}users/${firstImage}`}
                        alt={n.name}
                        className="image"
                        style={{height: '250px', objectFit: 'cover'}}
                      />
                      <div className="p-4">
                        <h3 className="font-semibold text-lg mb-2">{n.name}</h3>
                        {n.email && <p className="text-sm text-gray-600 mb-2">📧 {n.email}</p>}
                        {n.phone && <p className="text-sm text-gray-600">📞 {n.phone}</p>}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })
            ) : (
              <div style={{padding: '40px', textAlign: 'center'}}>No agents available</div>
            )}
          </Swiper>
        </div>
      </section>

      {/* Call to Action */}
      <section style={{backgroundColor: '#1572e8', color: 'white', padding: '60px 20px', textAlign: 'center'}}>
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-4">Ready to Find Your Next Home?</h2>
          <p className="mb-8 text-lg">Join thousands of satisfied customers who've found their perfect property on RoomsForYou.</p>
          <div style={{display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap'}}>
            <a href="/property" className="btn" style={{backgroundColor: 'white', color: '#1572e8', padding: '12px 30px', borderRadius: '6px', textDecoration: 'none', fontWeight: 'bold'}}>
              Browse Properties
            </a>
            <a href="/contact" className="btn" style={{backgroundColor: 'transparent', color: 'white', border: '2px solid white', padding: '10px 30px', borderRadius: '6px', textDecoration: 'none', fontWeight: 'bold'}}>
              Contact Us
            </a>
          </div>
        </div>
      </section>

    </>
  );
};

export default AboutPage;
